import { Controller } from "@hotwired/stimulus"
import JustValidate from "just-validate"

export default class extends Controller {
    connect() {
        this.validator = new JustValidate("#reminder-popup-form", {
            focusInvalidField: true,
            validateBeforeSubmitting: true,
        })

        this.validator
            .addField("#first_name_reminder", [
                { rule: "required", errorMessage: "First name is required" },
            ])
            .addField("#last_name_reminder", [
                { rule: "required", errorMessage: "Last name is required" },
            ])
            .addField("#email_reminder", [
                { rule: "required", errorMessage: "Email is required" },
                { rule: "email", errorMessage: "Please enter a valid email address" },
            ])
            .addField("select[name='recipient']", [
                { rule: "required", errorMessage: "Please select a recipient" },
            ])
            .addField("input[name='date_reminder']", [
                { rule: "required", errorMessage: "Date is required" },
            ])

        this.validator.onSuccess(() => {
            this.formTarget.submit();
        });
    }
}